module.exports = __webpack_public_path__ + "static/media/super-cloud.53a2ff11.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/super-cloud.png
// module id = 1536
// module chunks = 0